export default "__VITE_ASSET__89451aa1__"